import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import PageTransition from "@/components/motion/PageTransition";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import ProjectWizard from "@/pages/ProjectWizard";
import ReportPage from "@/pages/ReportPage";
import SettingsPage from "@/pages/SettingsPage";
import { ProjectProvider } from "@/context/ProjectContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  return (
    <PageTransition>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:projectId"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:projectId/wizard"
          element={
            <ProtectedRoute>
              <ProjectWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:projectId/report"
          element={
            <ProtectedRoute>
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </PageTransition>
  );
}

function App() {
  return (
    // reducedMotion="user" makes every framer-motion animation in the app
    // (including CSS-transform-only ones) obey the OS-level
    // prefers-reduced-motion setting automatically -- no per-component checks needed.
    <MotionConfig reducedMotion="user">
      <AuthProvider>
        <ProjectProvider>
          <div className="App min-h-screen bg-background">
            <div className="noise-overlay" />
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <Toaster position="bottom-right" richColors />
          </div>
        </ProjectProvider>
      </AuthProvider>
    </MotionConfig>
  );
}

export default App;
